document.addEventListener("DOMContentLoaded", function(){
    initMobileMenuSidebarCustomDropdownTrigger();
    initCustomSizeTabButtons();
    initCustomSizeChartTrigger();
    initCustomFrameButtons();
    initCustomThumbnailNavigation();
    initCustomCartStyles();
    initCustomPlayButton();

    popupDialogOverlayBugFix();
    ajaxLineItemRemoveFix();
})

window.addEventListener("load", function(){
    setInterval(function(){
        if(document.querySelector(".jdgm-row-media") && !document.querySelector(".jdgm-row-stars .jdgm-row-media")) {
            document.querySelector(".jdgm-row-stars").appendChild(document.querySelector(".jdgm-row-media"));
        }
    }, 50);

    setTimeout(function(){
        document.getElementByID("#pandectes-custom-css").remove();
    }, 500);
});

function initMobileMenuSidebarCustomDropdownTrigger() {
    document.addEventListener("click", function(e){
        if(window.innerWidth >= 1000) return;

        const target = e.target.closest("button.header-sidebar__linklist-button");
        if(!target) return;

        const container = target.closest("li");
        const scrollHeight = container.querySelector("ul").scrollHeight;
        target.closest("li").classList.toggle("active");

        if(container.classList.contains("active")) {
            container.querySelector("ul").style.height = "" + scrollHeight + "px";

            setTimeout(() => {
                container.querySelector("ul").style.height = "auto";
                container.querySelector("ul").style.overflow = "visible";
            }, 350);
        } else {
            container.querySelector("ul").style.height = "0px";

            setTimeout(() => {
                container.querySelector("ul").style.height = "0px";
                container.querySelector("ul").style.overflow = "hidden";
            }, 0);
        }
    });
}

function initCustomSizeTabButtons() {
    if(!document.querySelector("body").classList.contains("template-product")) return;

    const sizeVariants = document.querySelectorAll('variant-picker fieldset:first-of-type .variant-picker__option-values label');
    sizeVariants.forEach(variant => {
        const data = variant.getAttribute("data-value").split("/");
        const inch = data[0];
        const cm = data[1]; 

        document.querySelector(".but2").classList.remove("butactive");
        document.querySelector(".but1").classList.add("butactive");
        variant.textContent = inch;
    });
    
    document.addEventListener("click", function(e){
        const tab = e.target.closest(".btn-tab");
        if(!tab) return;

        sizeVariants.forEach(variant => {
            const data = variant.getAttribute("data-value").split("/");
            const inch = data[0];
            const cm = data[1]; 

            if(tab.classList.contains("but1")) {
                document.querySelector(".but2").classList.remove("butactive");
                tab.classList.add("butactive");
                variant.textContent = inch;
            } else {
                document.querySelector(".but1").classList.remove("butactive");
                tab.classList.add("butactive");
                variant.textContent = cm;
            }
        });
    });
}

function initCustomFrameButtons() {
    if(!document.querySelector("body").classList.contains("template-product")) return;

    document.addEventListener("click", function(e){
        const frame = e.target.closest("variant-picker fieldset:last-of-type .variant-picker__option-values label");
        if(!frame) return;

        const frameName= frame.querySelector("span")?.innerText;
        document.querySelector("variant-picker fieldset:last-of-type .variant-picker__option-info div span").innerText = frameName;
    })
}

function initCustomSizeChartTrigger() {
    if(!document.querySelector("body").classList.contains("template-product")) return;

    document.addEventListener("click", function(e){
        const trigger = e.target.closest(".select-size-chart");
        if(!trigger) return;

        if(window.innerWidth < 700) {
            document.querySelector(".shopify-section--main-product").scrollIntoView({ behavior: "smooth", block: "start" });
        }
        document.querySelector("product-gallery-navigation button:last-child").click();
    })
}

function initCustomThumbnailNavigation() {
    if (!document.body.classList.contains('template-product')) return;

    const container = document.querySelector('.product-gallery__thumbnail-list');
    if (!container) return;

    const prevBtn = container.querySelector('.custom_thumbnail_nav_prev');
    const nextBtn = container.querySelector('.custom_thumbnail_nav_next');

    if (!prevBtn || !nextBtn) return;

    const isVisible = el =>
        !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);

    const getThumbnails = () =>
        Array.from(container.querySelectorAll('.product-gallery__thumbnail'));

    const getActiveIndex = () => {
        const thumbs = getThumbnails();
        return thumbs.findIndex(
            thumb => thumb.getAttribute('aria-current') === 'true'
        );
    };

    const updateNavState = () => {
        if (!isVisible(prevBtn) || !isVisible(nextBtn)) return;

        const thumbs = getThumbnails();
        const activeIndex = getActiveIndex();

        prevBtn.disabled = activeIndex <= 0;
        nextBtn.disabled = activeIndex >= thumbs.length - 1;

        prevBtn.classList.toggle('is-disabled', prevBtn.disabled);
        nextBtn.classList.toggle('is-disabled', nextBtn.disabled);
    };

    const goToSlide = direction => {
        if (
        (direction === 'prev' && prevBtn.disabled) ||
        (direction === 'next' && nextBtn.disabled)
        ) {
            return;
        }

        const thumbs = getThumbnails();
        const activeIndex = getActiveIndex();
        if (activeIndex === -1) return;

        const targetIndex =
        direction === 'next' ? activeIndex + 1 : activeIndex - 1;

        const targetThumb = thumbs[targetIndex];
        if (targetThumb) {
            targetThumb.click();
        }
    };

    prevBtn.addEventListener('click', () => {
        if (!isVisible(prevBtn)) return;
        goToSlide('prev');
    });

    nextBtn.addEventListener('click', () => {
        if (!isVisible(nextBtn)) return;
        goToSlide('next');
    });

    // Watch aria-current updates from Shopify gallery
    const observer = new MutationObserver(updateNavState);

    getThumbnails().forEach(thumb => {
        observer.observe(thumb, {
            attributes: true,
            attributeFilter: ['aria-current']
        });
    });

    updateNavState();
}

function initCustomCartStyles() {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer.shadowRoot.querySelector("#vk-custom-cart")) {
        const style = document.createElement("style");
        style.id = "vk-custom-cart";
        style.textContent = `
            header button[aria-label="Close"] {
                opacity: 1 !important;
            }
        `;
        drawer.shadowRoot.appendChild(style);
    }

    document.addEventListener("cart-drawer:refreshed", (e) => {
        const drawer = e.target;

        if (!drawer.shadowRoot.querySelector("#vk-custom-cart")) {
            const style = document.createElement("style");
            style.id = "vk-custom-cart";
            style.textContent = `
            header button[aria-label="Close"] {
                opacity: 1 !important;
            }
            `;
            drawer.shadowRoot.appendChild(style);
        }
    });
}

function initCustomPlayButton() {
    const videoMedias = document.querySelectorAll("video-media");
    if (!videoMedias.length) return;

    videoMedias.forEach(videoMedia => {
        const video = videoMedia.querySelector("video");
        const playButton = videoMedia.querySelector(".custom_play_button");

        if (!video || !playButton) return;

        const updateButtonVisibility = () => {
            if (!video.paused && !video.ended) {
                playButton.classList.add("hide");
            } else {
                playButton.classList.remove("hide");
            }
        };

        let hasStarted = false;

        // Initial state
        updateButtonVisibility();

        // Video state changes
        video.addEventListener("play", () => {
            hasStarted = true;           // first real play happens here
            updateButtonVisibility();
        });

        video.addEventListener("pause", updateButtonVisibility);
        video.addEventListener("ended", updateButtonVisibility);

        // Toggle only AFTER first play
        videoMedia.addEventListener("click", () => {
            if (!hasStarted) return;     // 👈 skip first interaction

            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
        });
    });
}

function popupDialogOverlayBugFix() {
    const drawers = [
      { el: document.querySelector("cart-drawer"), disabled: false },
      { el: document.querySelector("facets-drawer"), disabled: false }
    ];

    const observer = new MutationObserver(() => {
      const popup = document.querySelector("div[data-testid='FULLSCREEN']");

      drawers.forEach(drawer => {
        if (!drawer.el || !drawer.el.focusTrap) return;

        if (popup && drawer.el.open && !drawer.disabled) {
          drawer.disabled = true;
          drawer.el.focusTrap.deactivate();
        }

        if (!popup && drawer.disabled && drawer.el.open) {
          drawer.disabled = false;
          drawer.el.focusTrap.activate();
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
}

function ajaxLineItemRemoveFix() {
    document.addEventListener("click", function(e){
        const target = e.target.closest(".line-item-info > div > div:first-child a:last-child");
        if(!target) return;
        e.preventDefault();

        const lineItemInfo = target.closest(".line-item-info");
        
        if(lineItemInfo) {
            lineItemInfo.querySelector("line-item-quantity a").click();
        }
    });
}